export const load = () => ({
	title: 'Performance of Storm Windows vs Regular Windows',
	showTitle: true,
});
